<template>
  <div class="font-size-h2 text-footer px-4 my-5">ONLINE REGISTRATION IS NOT AVAILABLE FOR THIS SITE.</div>
</template>

<script>
export default {
  name: 'NoSubscription'
}
</script>
